import { MutationTree } from 'vuex';
import { NoteReclamationState } from './state';
import { NOTE_RECLAMATION } from '@/modules/NoteReclamation/store/mutation-types';

export const mutations: MutationTree<NoteReclamationState> = {
    [NOTE_RECLAMATION.SET_JWT](state, jwt: string) {
        state.jwt = jwt;
    },
    [NOTE_RECLAMATION.RESET_JWT](state) {
        state.jwt = '';
    },
};
